var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCelebrateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.318 8.67525L11.692 7.14928C11.8041 7.02484 11.8412 6.85006 11.7895 6.69078C11.7377 6.53147 11.6049 6.41194 11.4411 6.37712L9.43261 5.95022L8.40589 4.17188C8.32217 4.02684 8.16742 3.9375 7.99995 3.9375C7.83248 3.9375 7.67773 4.02684 7.59401 4.17188L6.56732 5.95022L4.55879 6.37712C4.39498 6.41194 4.2622 6.53147 4.21045 6.69078C4.1587 6.85006 4.19586 7.02481 4.30792 7.14928L5.68192 8.67525L5.46726 10.7174C5.44973 10.884 5.52242 11.0472 5.65792 11.1456C5.79342 11.2441 5.97114 11.2627 6.12411 11.1946L7.99995 10.3594L9.87582 11.1947C9.93686 11.2218 10.0018 11.2352 10.0664 11.2352C10.1639 11.2352 10.2606 11.2048 10.342 11.1457C10.4775 11.0473 10.5502 10.884 10.5327 10.7174L10.318 8.67525Z",
    fill: "#5A608D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.09375C8.25888 3.09375 8.46875 2.88388 8.46875 2.625V1.96875C8.46875 1.70987 8.25888 1.5 8 1.5C7.74112 1.5 7.53125 1.70987 7.53125 1.96875V2.625C7.53125 2.88388 7.74109 3.09375 8 3.09375Z",
    fill: "#5A608D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08008 12.9629C7.8212 12.9629 7.61133 13.1728 7.61133 13.4316L7.61133 14.0879C7.61133 14.3468 7.8212 14.5566 8.08008 14.5566C8.33895 14.5566 8.54883 14.3468 8.54883 14.0879L8.54883 13.4316C8.54883 13.1728 8.33898 12.9629 8.08008 12.9629Z",
    fill: "#5A608D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9351 7.43555H13.2788C13.0199 7.43555 12.8101 7.64542 12.8101 7.9043C12.8101 8.16317 13.0199 8.37305 13.2788 8.37305H13.9351C14.1939 8.37305 14.4038 8.16317 14.4038 7.9043C14.4038 7.64542 14.1939 7.43555 13.9351 7.43555Z",
    fill: "#5A608D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18945 7.9043C3.18945 7.64542 2.97958 7.43555 2.7207 7.43555H2.06445C1.80558 7.43555 1.5957 7.64542 1.5957 7.9043C1.5957 8.16317 1.80558 8.37305 2.06445 8.37305H2.7207C2.97958 8.37305 3.18945 8.16317 3.18945 7.9043Z",
    fill: "#5A608D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7329 4.63907C11.8529 4.63907 11.9729 4.59329 12.0644 4.50176L13.4085 3.1576C13.5916 2.97457 13.5916 2.67776 13.4085 2.4947C13.2255 2.31166 12.9287 2.31166 12.7456 2.4947L11.4015 3.83885C11.2184 4.02188 11.2184 4.3187 11.4015 4.50176C11.493 4.59329 11.613 4.63907 11.7329 4.63907Z",
    fill: "#5A608D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0644 11.3052C11.8813 11.1222 11.5845 11.1222 11.4015 11.3052C11.2184 11.4883 11.2184 11.7851 11.4015 11.9681L12.7456 13.3123C12.8371 13.4038 12.9571 13.4496 13.0771 13.4496C13.197 13.4496 13.317 13.4038 13.4085 13.3123C13.5916 13.1293 13.5916 12.8325 13.4085 12.6494L12.0644 11.3052Z",
    fill: "#5A608D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.93555 11.3052L2.5914 12.6494C2.40834 12.8324 2.40834 13.1292 2.5914 13.3123C2.68293 13.4038 2.8029 13.4496 2.92284 13.4496C3.04277 13.4496 3.16277 13.4038 3.25427 13.3123L4.59843 11.9681C4.78149 11.7851 4.78149 11.4883 4.59843 11.3052C4.4154 11.1222 4.11859 11.1222 3.93555 11.3052Z",
    fill: "#5A608D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.93552 4.50176C4.02705 4.59329 4.14702 4.63907 4.26696 4.63907C4.3869 4.63907 4.5069 4.59329 4.5984 4.50176C4.78146 4.31873 4.78146 4.02191 4.5984 3.83885L3.2543 2.4947C3.07127 2.31166 2.77446 2.31166 2.5914 2.4947C2.40834 2.67773 2.40834 2.97454 2.5914 3.1576L3.93552 4.50176Z",
    fill: "#5A608D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96889 3.5157C10.2051 3.62167 10.4825 3.51611 10.5885 3.27989C10.6944 3.0437 10.5889 2.7663 10.3526 2.66033C10.1165 2.55436 9.83905 2.65992 9.73308 2.89614C9.62711 3.13233 9.7327 3.4097 9.96889 3.5157Z",
    fill: "#5A608D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1107 12.5409C5.87451 12.435 5.59711 12.5405 5.49114 12.7768C5.38517 13.0129 5.49073 13.2903 5.72695 13.3963C5.96314 13.5023 6.24054 13.3967 6.34651 13.1605C6.45248 12.9243 6.34689 12.6469 6.1107 12.5409Z",
    fill: "#5A608D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1005 6.46358C13.3424 6.37149 13.4639 6.10071 13.3718 5.85877C13.2797 5.61683 13.0089 5.49533 12.767 5.58743C12.525 5.67952 12.4035 5.9503 12.4956 6.19227C12.5877 6.43418 12.8585 6.55568 13.1005 6.46358Z",
    fill: "#5A608D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6247 10.4922C12.8608 10.5982 13.1382 10.4926 13.2442 10.2564C13.3502 10.0202 13.2446 9.74283 13.0084 9.63689C12.7722 9.53092 12.4948 9.63648 12.3888 9.8727C12.2829 10.1089 12.3885 10.3863 12.6247 10.4922Z",
    fill: "#5A608D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8993 9.34329C2.65736 9.43538 2.53586 9.70617 2.62795 9.9481C2.72005 10.1901 2.99083 10.3115 3.2328 10.2194C3.47474 10.1274 3.59624 9.85657 3.50414 9.6146C3.41205 9.37267 3.14127 9.2512 2.8993 9.34329Z",
    fill: "#5A608D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37511 5.31462C3.13892 5.20866 2.86151 5.31422 2.75554 5.55044C2.64957 5.78662 2.75514 6.06403 2.99132 6.16997C3.22754 6.27594 3.50492 6.17037 3.61089 5.93416C3.71689 5.698 3.61129 5.42059 3.37511 5.31462Z",
    fill: "#5A608D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.10382 3.48366C6.34176 3.38163 6.45188 3.10603 6.34985 2.8681C6.24779 2.63016 5.9722 2.52 5.73429 2.62207C5.49638 2.72413 5.38623 2.99972 5.48826 3.23763C5.59029 3.47553 5.86588 3.58569 6.10382 3.48366Z",
    fill: "#5A608D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97626 12.573C9.73832 12.675 9.62819 12.9506 9.73023 13.1885C9.83229 13.4265 10.1079 13.5366 10.3458 13.4346C10.5837 13.3325 10.6939 13.0569 10.5918 12.819C10.4898 12.5811 10.2142 12.471 9.97626 12.573Z",
    fill: "#5A608D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrateIcon);
export default __webpack_public_path__ + "static/media/celebrate-icon.dcafb3dc.svg";
export { ForwardRef as ReactComponent };